"use client";
import React from "react";
import "react-image-lightbox/style.css";
import { useTranslations } from "next-intl";
import CommonTaile from "../Common/CommonTaile";
import TechnicalSupportEcosystem from "./TechnicalSupportEcosystem";
import VissonCard from "./VissonCard";
import IntroductionCard from "./IntroductionCard";
import ManufacturingCapabilities from "./ManufacturingCapabilities";
import EcoCompliance from "./EcoCompliance";
import TeamGallery from "./TeamGallery";
import Sponsor from "./Sponsor";

function Index() {
  const t = useTranslations();

  const breadcrumbItems = [
    { label: t('menu.home'), link: '/' },
    { label: t('menu.aboutUs'), link: '' },
  ];

  return (
    <>
        <CommonTaile msg={t('menu.aboutUs')} backgroundImage="/image/plsyy/about-banner.webp" breadcrumbItems={breadcrumbItems} pageSlug="about-us" />
        <IntroductionCard />
        <VissonCard />
        <TechnicalSupportEcosystem />
        <ManufacturingCapabilities />
        <EcoCompliance />
        <TeamGallery />
        <Sponsor />
    </>
  );
}

export default React.memo(Index);
